import { Button, Drawer } from 'antd';
import { useTranslation } from 'translations/hooks';

export enum AlertAction {
  Cancel = 'cancel',
  Validate = 'validate',
}

export const AlertDrawer = ({
  message,
  isOpen,
  setIsOpen,
  action = AlertAction.Cancel,
}: {
  message: string;
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  action?: AlertAction;
}) => {
  const { t } = useTranslation();

  return (
    <Drawer
      className="drawer-sidebar"
      open={isOpen}
      placement="bottom"
      closable={false}
      size={225}
    >
      <div className="flex flex-col items-center justify-between gap-8 px-8 py-4">
        <div className="text-center text-xl">{message}</div>

        <Button
          color="primary"
          variant="outlined"
          block
          size="large"
          onClick={() => setIsOpen(false)}
        >
          {action === AlertAction.Validate
            ? t('common.validate')
            : t('common.cancel')}
        </Button>
      </div>
    </Drawer>
  );
};
